/*
 * Convert a string into a number
 * @param {String} the string to clean - e.g. '$500.40'
 * @return {Number} the number value of the string
 */
var stringToNumber = function stringToNumber(str) {
  if (str === null) {
    return null;
  }

  return Number(String(str).replace(/[^0-9.]+/g, ''));
};

export default stringToNumber;